// Module
var code = `<div tabindex="0" class="js-dt-container {{#.focused}}active{{/}}" style="left:{{.left}}px;top:{{.top}}px;"
    on-focus="containerFocus"
    on-keydown="containerKeyDown">
    {{#.dateTime}}
    <div class="date-time-container">
        <div class="date-container">
            <div tabindex="-1" class="js-dt-el day" 
                on-focus="['focus', 'day']"
                on-blur="['blur', 'day']"
                on-keydown="['keyDown' ,'day']" 
                on-wheel="['mouseWheel', 'day']"
                on-mousewheel="['mouseWheel', 'day']">
                {{.day}}
            </div>
            
            <div class="js-dt-separator">.</div>
            
            <div tabindex="-1" class="js-dt-el month"
                on-focus="['focus', 'month']"
                on-blur="['blur', 'month']"
                on-keydown="['keyDown', 'month']" 
                on-wheel="['mouseWheel', 'month']"
                on-mousewheel="['mouseWheel', 'month']">
                {{.month}}
            </div>
            
            <div class="js-dt-separator">.</div>
            
            <div tabindex="-1" class="js-dt-el year"
                on-focus="['focus', 'year']"
                on-blur="['blur', 'year']"
                on-keydown="['keyDown', 'year']"
                on-wheel="['mouseWheel', 'year']"
                on-mousewheel="['mouseWheel', 'year']">
                {{.year}}
            </div>
        </div>
        <div class="time-container">
            <div tabindex="-1" class="js-dt-el hours"
                on-focus="['focus', 'hours']"
                on-blur="['blur', 'hours']"
                on-keydown="['keyDown', 'hours']"
                on-wheel="['mouseWheel', 'hours']"
                on-mousewheel="['mouseWheel', 'hours']">
                {{.hours}}
            </div>
            
            <div class="js-dt-separator">:</div>
            
            <div tabindex="-1" class="js-dt-el minutes"
                on-focus="['focus', 'minutes']"
                on-blur="['blur', 'minutes']"
                on-keydown="['keyDown', 'minutes']"
                on-wheel="['mouseWheel', 'minutes']"
                on-mousewheel="['mouseWheel', 'minutes']">
                {{.minutes}}
            </div>
            
            <div class="js-dt-separator">:</div>
            
            <div tabindex="-1" class="js-dt-el seconds"
                on-focus="['focus', 'seconds']"
                on-blur="['blur', 'seconds']"
                on-keydown="['keyDown', 'seconds']"
                on-wheel="['mouseWheel', 'seconds']"
                on-mousewheel="['mouseWheel', 'seconds']">
                {{.seconds}}
            </div>
        </div>
    </div>
    <terceraButton
        name="{{#if .dateFromStyle}}fromDateIcon{{else}}toDateIcon{{/if}}"
        SVG="true"
        checked="{{isDatePickerOpen}}"
        terceraButtonStyle="js-dt-button"
        on-componentClick="onClick"/>
    <!-- <div class="js-dt-button" on-click="onClick">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{#if .dateFromStyle}}fromDateIcon{{else}}toDateIcon{{/if}}"></use>
        </svg>
    </div> -->
    {{/}}
</div>`;
// Exports
export default code;